import addLog from './addLog';
import update from './update';

export default {
  addLog,
  update,
};
